import { Navigate } from "react-router-dom";
import Login from "../pages/auth/login/Login";
import SignUp from "../pages/auth/signUp/SignUp";
import ResetPassword from "../pages/auth/resetPassword/ResetPassword";
import Registration from "../pages/auth/registration/registration";
import UnderReviewNote from "../pages/auth/registration/UnderReview";
import ProfileRejected from "../pages/auth/registration/ProfileRejected";
import Home from "../pages/web/home/Home";
import Profile from "../pages/web/profile/Profile";
import NotificationAll from "../pages/web/notifications/Notification";
import ChangePassword from "../pages/web/profile/ChangePassword";
import MyProfile from "../pages/web/profile/my-profile/MyProfile";
import LeadContact from "../pages/web/enquire/lead-contact/LeadContact";
import InquiryList from "../pages/web/profile/inquiryList/Inquirylist";





export const PrivateRoutes = [
    // {
    //     path: "home",
    //     element: <Home />
    // },
    // {
    //     path: "notifications",
    //     element: <NotificationAll />
    // }
]
export const ProfileRoutes = [
    {
        path: "profile",
        element: <Profile/>,
    },
    {
        path: "change-password",
        element: <ChangePassword />,
    },
    {
        path: "my-profile",
        element: <MyProfile />,
    },
    {
        path: "inquiry-list",
        element: <InquiryList />,
    },
    // {
    //     path: "registration",
    //     element: <Registration />
    // },
    {
        path: "under-review",
        element: <UnderReviewNote />
    },
    {
        path: "profile-rejected",
        element: <ProfileRejected />
    },
]